<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <p class="gris--text">Historial de acciones de <b>usuarios</b></p>
      </v-col>
    </v-row>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        class="elevation-1"
      >
        <!-- formato de fecha -->
        <template v-slot:[`item.created_at`]="{ item }">
          {{ new Date(item.created_at).toLocaleString() }}
        </template>
      </v-data-table>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      headers: [
        { text: "Acción", value: "Accion" },
        { text: "Descripción", value: "Descripcion" },
        { text: "Usuario", value: "Nombres" },
        { text: "Fecha", value: "created_at" },
      ],
      items: [],
      total: 0,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["created_at"],
        sortDesc: [true],
      },
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  methods: {
    async fetchData() {
        const { page, itemsPerPage } = this.options;
              this.$http.get(`history/users`, {
          params: { page, pageSize: itemsPerPage },
        })
        .then(response => {
            this.items = response.data.data;
            this.total = response.data.total;
        })
        .catch(() => {
        })
        .finally(() => {
        });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
